module.exports = __webpack_public_path__ + "img/labmemtest_btn_download_kr.e0913660.png";